module.exports = __webpack_public_path__ + "img/icon_Government_white.57b544a5.svg";